var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:camera"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.1663 11.1667H19.5413L25.1247 5.58334H41.8747L47.458 11.1667H55.833C57.3138 11.1667 58.7339 11.7549 59.781 12.802C60.8281 13.8491 61.4163 15.2692 61.4163 16.75V50.25C61.4163 51.7308 60.8281 53.1509 59.781 54.198C58.7339 55.2451 57.3138 55.8333 55.833 55.8333H11.1663C9.68555 55.8333 8.26541 55.2451 7.21833 54.198C6.17125 53.1509 5.58301 51.7308 5.58301 50.25V16.75C5.58301 15.2692 6.17125 13.8491 7.21833 12.802C8.26541 11.7549 9.68555 11.1667 11.1663 11.1667ZM33.4997 19.5417C29.7977 19.5417 26.2473 21.0123 23.6296 23.63C21.0119 26.2477 19.5413 29.798 19.5413 33.5C19.5413 37.202 21.0119 40.7523 23.6296 43.37C26.2473 45.9877 29.7977 47.4583 33.4997 47.4583C37.2017 47.4583 40.752 45.9877 43.3697 43.37C45.9874 40.7523 47.458 37.202 47.458 33.5C47.458 29.798 45.9874 26.2477 43.3697 23.63C40.752 21.0123 37.2017 19.5417 33.4997 19.5417ZM33.4997 25.125C35.7209 25.125 37.8511 26.0074 39.4217 27.578C40.9923 29.1486 41.8747 31.2788 41.8747 33.5C41.8747 35.7212 40.9923 37.8514 39.4217 39.422C37.8511 40.9926 35.7209 41.875 33.4997 41.875C31.2785 41.875 29.1483 40.9926 27.5777 39.422C26.007 37.8514 25.1247 35.7212 25.1247 33.5C25.1247 31.2788 26.007 29.1486 27.5777 27.578C29.1483 26.0074 31.2785 25.125 33.4997 25.125Z",
    fill: "#076AFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.de7abb967dfb83cd0569d93e0529e1d2.svg";
export { ForwardRef as ReactComponent };